require('./focusIf');
module.exports = 'focus-if';



//////////////////
// WEBPACK FOOTER
// ./~/ng-focus-if/index.js
// module id = 153
// module chunks = 0